module.exports = "https://static.zego.com/_next/static/images/opengraph-es-01649c86f70cc72ca77093b66315042d.png";